import cn from "clsx";
import { DataPanel } from "react-migration/components/DataPanel";

export const ComparableDetailCard = ({
  children,
  disabled = false,
  size = "md",
  title,
  tooltip,
  onClick,
  dataTestId,
}: {
  children: React.ReactNode;
  disabled?: boolean;
  size?: "sm" | "md";
  title?: string;
  tooltip?: string;
  onClick?: () => void;
  dataTestId?: string;
}) => {
  return (
    <DataPanel.Cell
      variant={disabled ? "default" : "light"}
      title={title}
      tooltip={tooltip}
      data-testid={dataTestId}
      className={cn("justify-self-stretch self-stretch", {
        "p-4!": size === "md",
        "p-2!": size === "sm",
        "cursor-pointer": onClick,
      })}
      onClick={onClick}
    >
      <div
        className={cn("p-0! m-0", {
          "blur-[6px] pointer-events-none": disabled,
        })}
      >
        {children}
      </div>
    </DataPanel.Cell>
  );
};
